<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
          <div style="display: flex;justify-content:flex-start;">
            <el-form-item>
                <el-date-picker v-model="createTime" type="datetimerange" range-separator="-"
                    start-placeholder="开始日期" end-placeholder="结束日期" align="left" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" @change="dateChange">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                <el-button type="primary" icon="el-icon-download" size="small" @click="onExport">导出</el-button>
            </el-form-item>
        </div>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix flex_s_b">
                        <span class="money_title">用户总量</span>
                        <!-- <span class="look_over" @click="toMbuser">查看</span> -->
                        <el-button type="text" style="font-size: 16px;" icon="el-icon-view el-icon--right" @click="toMbuser">查看</el-button>
                    </div>
                    <span class="money_content">{{tolusernum}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">用户地区来源</span>
                    </div>
                    <span class="money_content">{{regionSource}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix flex_s_b">
                        <span class="money_title">活跃度</span>
                        <!-- <span class="look_over" @click="toMbuser">查看</span> -->
                        <el-button type="text" style="font-size: 16px;" icon="el-icon-view el-icon--right" @click="toMbuser">查看</el-button>
                    </div>
                    <span class="money_content">{{activity}}%</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix flex_s_b">
                        <span class="money_title">商品数量</span>
                        <!-- <span class="look_over" @click="toProduct">查看</span> -->
                        <el-button type="text" style="font-size: 16px;" icon="el-icon-view el-icon--right" @click="toProduct">查看</el-button>
                    </div>
                    <span class="money_content">{{numOfGoods}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">被关注商品</span>
                    </div>
                    <span class="money_content">{{comOfConcern}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">商品浏览量</span>
                    </div>
                    <span class="money_content">{{comOfViews}}</span>
                </el-card>
            </el-form-item>

            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">销售额</span>
                    </div>
                    <span class="money_content">{{salesVolume}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix flex_s_b">
                        <span class="money_title">订单总量（销售量）</span>
                        <!-- <span class="look_over" @click="toOrder">查看</span> -->
                        <el-button type="text" style="font-size: 16px;" icon="el-icon-view el-icon--right" @click="toOrder">查看</el-button>
                    </div>
                    <span class="money_content">{{tolordernum}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">销售人员销售额</span>
                    </div>
                    <span class="money_content">{{salespersonVolume}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">销售人员销售量（订单量）</span>
                    </div>
                    <span class="money_content">{{salespersonCount}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">销售地区统计</span>
                    </div>
                    <span class="money_content">{{salesArea}}</span>
                </el-card>
            </el-form-item>

            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix flex_s_b">
                        <span class="money_title">商品询价量统计</span>
                        <!-- 暂无询价管理 -->
                        <!-- <span class="look_over" @click="toInquiry">查看</span> -->
                        <el-button type="text" style="font-size: 16px;" icon="el-icon-view el-icon--right" @click="toInquiry">查看</el-button>
                    </div>
                    <span class="money_content">{{enquiryCountVolume}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">商品询价地区统计</span>
                    </div>
                    <span class="money_content">{{enquiryAreaVolume}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">序列号验证统计</span>
                    </div>
                    <span class="money_content">{{serialNumberChecked}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">搜素次数统计</span>
                    </div>
                    <span class="money_content">{{searchCount}}</span>
                </el-card>
            </el-form-item>
            <!-- <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">订单量</span>
                    </div>
                    <span class="money_content">{{ordernum}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">用户注册量</span>
                    </div>
                    <span class="money_content">{{regnum}}</span>
                </el-card>
            </el-form-item> -->
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">IP/PV</span>
                    </div>
                    <span class="money_content">{{ippv}}</span>
                </el-card>
            </el-form-item>
            <el-form-item>
                <el-card class="main-card">
                    <div slot="header" class="clearfix">
                        <span class="money_title">积分获取/消耗</span>
                    </div>
                    <span class="money_content">{{mbinte}}</span>
                </el-card>
            </el-form-item>



        </el-form>

        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;">  ref="multipleTable"
            v-loading="loading"      -->
        <!-- <el-table :data="list" :header-cell-style="{background:'#F4F4F5',color:'#606266'}" border>
            <el-table-column label="时间" prop="time" align="center" />
            <el-table-column label="订单量" prop="ordernum" align="center" />
            <el-table-column label="用户注册量" prop="regnum" align="center" />
            <el-table-column label="IP/PV" prop="ippv" align="center" />
            <el-table-column label="积分获取/消耗" prop="intexp" align="center" />
        </el-table> -->

        <!-- <el-pagination
            class="pagination-container"
            background
            :page-size="query.pageSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper"
            :page-sizes="[10, 20, 30, 50]"
            :total="totalNumber"
        ></el-pagination> -->

    </div>
</template>

<script>
    import {
        getList,
        getInits
    } from "../../api/data/data";
    import {
        BASE_URL
    } from "../../config/app";
    export default {
        data() {
            return {
                balance: 0,
                tolusernum: 0, // 用户总量
                tolordernum: 0, // 订单总量
                ordernum: 0, // 订单量
                regnum: 0, // 用户注册量
                ippv: "0/0", // IpPv
                mbinte: "0/0", // 积分获取和消耗
                activity:0, //活跃度
                comOfConcern:0, //被关注商品
                comOfViews:0, //商品浏览量
                numOfGoods:0, //商品数量
                regionSource:0, //用户地区来源
                salesArea:0, //	销售地区统计
                salesVolume:0, //	销售额
                salespersonCount:0, //		销售人员销售量
                salespersonVolume:0, //		销售人员销售额
                searchCount:0, //			搜索次数
                serialNumberChecked:0, //	序列号验证统计
                enquiryCountVolume:0, //	商品询价量统计
                enquiryAreaVolume:0, //	商品询价地区统计
                type: "nit",
                createTime: [],
                query: {
                    startTime: "",
                    endTime: "",
                    type: "nit"
                },
                list: [],
                totalNumber: 0,
                loading: false,
                index: null,
                formLoading: false,
                formVisible: false
            };
        },

        methods: {
          toMbuser(){
            this.$router.push({
                path: "/mbUser",
            });
          },
          toProduct(){
            this.$router.push({
                path: "/product/product",
            });
          },
          toOrder(){
            this.$router.push({
                path: "/order/saleorder",
            });
          },
          toInquiry(){
            this.$router.push({
                path: "/inquiry/list",
            });
          },
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                //this.getList();
            },
            onSubmit() {
                this.query.type = "hit"
                this.getList();
            },
            onRest() {
                this.query = {
                    startTime: "",
                    endTime: "",
                    type: "nit"
                };
                this.getList();
            },
            onExport() {
                console.info(this.query.startTime.length)
                if (this.query.startTime != "" && this.query.endTime != "") {
                    window.location.href = BASE_URL + "/hp/export?startTime=" + this.query.startTime + "&endTime=" +
                        this.query.endTime
                } else {
                    this.$message.warning("请选择开始时间和结束时间")
                }

            },
            getList() {
                getList(this.query)
                    .then(response => {
                        console.log(response.data)
                        let json = response.data.data
                        console.log(json)
                        this.tolusernum = json.tolusernum // 用户总量
                        this.tolordernum = json.tolordernum // 订单总量
                        this.ordernum = json.ordernum // 订单量
                        this.regnum = json.regnum // 用户注册量
                        this.ippv = json.ippv // IpPv
                        this.mbinte = json.mbinte // 积分获取和消耗
                        this.list = json.dataPageVO
                        // console.log(this.list)

                        this.activity = json.activity // 活跃度
                        this.comOfConcern = json.comOfConcern // 被关注商品
                        this.comOfViews = json.comOfViews // 商品浏览量
                        this.numOfGoods = json.numOfGoods // 商品数量
                        this.regionSource = json.regionSource // 用户地区来源
                        this.salesArea = json.salesArea // 销售地区统计
                        this.salesVolume = json.salesVolume // 销售额
                        this.salespersonCount = json.salespersonCount // 销售人员销售量
                        this.salespersonVolume = json.salespersonVolume // 销售人员销售额
                        this.searchCount = json.searchCount // 搜索次数
                        this.serialNumberChecked = json.serialNumberChecked // 序列号验证统计
                        this.enquiryCountVolume = json.enquiryCountVolume // 商品询价量统计
                        this.enquiryAreaVolume = json.enquiryAreaVolume // 商品询价地区统计

                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            getInit() {
                getInits(this.query)
                    .then(response => {
                        //console.log(response.data)
                        let json = response.data.data
                        //console.log(json)
                        this.tolusernum = json.tolusernum // 用户总量
                        this.tolordernum = json.tolordernum // 订单总量
                        this.ordernum = json.ordernum // 订单量
                        this.regnum = json.regnum // 用户注册量
                        this.ippv = json.ippv // IpPv
                        this.mbinte = json.mbinte // 积分获取和消耗
                        this.activity = json.activity // 活跃度
                        this.comOfConcern = json.comOfConcern // 被关注商品
                        this.comOfViews = json.comOfViews // 商品浏览量
                        this.numOfGoods = json.numOfGoods // 商品数量
                        this.regionSource = json.regionSource // 用户地区来源
                        this.salesArea = json.salesArea // 销售地区统计
                        this.salesVolume = json.salesVolume // 销售额
                        this.salespersonCount = json.salespersonCount // 销售人员销售量
                        this.salespersonVolume = json.salespersonVolume // 销售人员销售额
                        this.searchCount = json.searchCount // 搜索次数
                        this.serialNumberChecked = json.serialNumberChecked // 序列号验证统计
                        this.enquiryCountVolume = json.enquiryCountVolume // 商品询价量统计
                        this.enquiryAreaVolume = json.enquiryAreaVolume // 商品询价地区统计
                  })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            }

        },
        created() {
            console.log("初始数据")
            this.getInit();
        },
        filters: {
            price: function (myInput) {
                var val = parseInt(myInput);
                if (typeof val === "number") {
                    return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
                }
            }
        }
    };

</script>

<style type="text/scss" lang="scss">
    body {
        margin: 0;
    }
    .main-card {
        min-width: 255px;
        box-shadow: 3px 2px 10px 0 rgba(0, 0, 0, 0.6) !important;
        .el-card__header {
            padding: 10px 20px !important;
        }
    }
    .money_title {
        font-size: 16px;
        height: 37px;
        line-height: 37px;
    }
    .look_over {
      font-size: 16px;
      color: #409eff;
      cursor: pointer;
    }
    .money_content {
        font-size: 30px;
        color: #409eff;
    }
    .main_date_picker {
        float: right;
        min-width: 100px;
    }
.flex_s_b {
  display: flex;
  justify-content: space-between;
}
    @media screen and (max-width: 1900px) {
        .main-card {
            width: 375px;
        }
        .main_date_picker {
            width: 200px !important;
        }
    }
    @media screen and (max-width: 1800px) {
        .main-card {
            width: 350px;
        }
        .main_date_picker {
            width: 180px !important;
        }
    }
    @media screen and (max-width: 1700px) {
        .main-card {
            width: 325px;
        }
        .main_date_picker {
            width: 160px !important;
        }
    }
    @media screen and (max-width: 1600px) {
        .main-card {
            width: 300px;
        }
        .main_date_picker {
            width: 140px !important;
        }
    }
    @media screen and (max-width: 1500px) {
        .main-card {
            width: 275px;
        }
        .main_date_picker {
            width: 120px !important;
        }
    }
    @media screen and (max-width: 1400px) {
        .main-card {
            width: 250px;
        }
        .main_date_picker {
            width: 100px !important;
        }
    }
    @media screen and (max-width: 1300px) {
        .main-card {
            width: 225px;
        }
    }
    @media screen and (max-width: 1200px) {
        .main-card {
            width: 200px;
        }
    }
    @media screen and (max-width: 1100px) {
        .main-card {
            width: 175px;
        }
    }
    @media screen and (max-width: 768px) {
        .main-card {
            width: 375px;
        }
        .main_date_picker {
            width: 230px !important;
        }
    }
</style>
